import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import infoList from "@/components/mixins/infoList";
import { getAllFolders } from "@/api/file_service";
import { addFileRoleWithFolder, getFoldersByRoleId } from "@/api/file_role";
import { mapGetters } from 'vuex';
export default {
  name: "Folder",
  mixins: [infoList],
  data: function data() {
    return {
      data: [],
      filterText: '',
      treeData: [],
      // listApi: getAllFirstFolder,
      defaultProps: {
        label: 'name',
        id: 'ID',
        pid: 'pid'
      },
      selectedIds: [],
      selectedAllIds: [],
      userTransferData: [],
      userTransferModel: []
    };
  },
  props: {
    row: {
      default: function _default() {
        return {};
      },
      type: Object
    }
  },
  watch: {
    filterText: function filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var lists, halflist;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return this.getFolderListFunc();
          case 1:
            _context.next = 2;
            return this.getFoldersByRoleIdFunc();
          case 2:
            console.log(this.$refs.tree.getCheckedKeys());
            lists = this.$refs.tree.getCheckedKeys();
            halflist = this.$refs.tree.getHalfCheckedKeys();
            this.selectedIds = lists.concat(halflist);
            // lists.forEach(item => {
            //   if (item !== null) {
            //     this.selectedIds.push(item.ID)
            //   }
            // });
            // halflist.forEach(item => {
            //   if (item !== null) {
            //     this.selectedIds.push(item.ID)
            //   }
            // });
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {
    filterNode: function filterNode(value, data) {
      // console.log(value,data)
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    saveFileRoleWithFolders: function () {
      var _saveFileRoleWithFolders = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return addFileRoleWithFolder({
                RoleId: this.row.ID,
                FolderIds: this.selectedIds
              });
            case 1:
              return _context2.abrupt("return", _context2.sent);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function saveFileRoleWithFolders() {
        return _saveFileRoleWithFolders.apply(this, arguments);
      }
      return saveFileRoleWithFolders;
    }(),
    getFoldersByRoleIdFunc: function () {
      var _getFoldersByRoleIdFunc = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this = this;
        var res, a;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 1;
              return getFoldersByRoleId({
                RoleId: this.row.ID
              });
            case 1:
              res = _context3.sent;
              if (res.code == 0) {
                a = res.data.ids; // this.selectedAllIds = a;
                this.$nextTick(function () {
                  _this.$refs.tree.setCheckedKeys(a);
                });
                // console.log(this.selectedAllIds)
              } else {
                this.$message.error(res.msg);
              }
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getFoldersByRoleIdFunc() {
        return _getFoldersByRoleIdFunc.apply(this, arguments);
      }
      return getFoldersByRoleIdFunc;
    }(),
    handleCheckFunc: function handleCheckFunc(nodeObj, selectedObj) {
      var _this2 = this;
      this.selectedIds = [];
      var lists = selectedObj.checkedNodes;
      var halflist = selectedObj.halfCheckedNodes;
      lists.forEach(function (item) {
        _this2.selectedIds.push(item.ID);
      });
      halflist.forEach(function (item) {
        _this2.selectedIds.push(item.ID);
      });
      // console.log(this.selectedIds);
    },
    getFolderListFunc: function () {
      var _getFolderListFunc = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res, lists;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 1;
              return getAllFolders();
            case 1:
              res = _context4.sent;
              if (res.code == 0) {
                lists = res.data.folders;
                this.treeData = this.getListData(lists, 0, this.defaultProps);
                // console.log(JSON.stringify(this.treeData));
              }
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getFolderListFunc() {
        return _getFolderListFunc.apply(this, arguments);
      }
      return getFolderListFunc;
    }(),
    getListData: function getListData(datas, bigPid, defaultProp) {
      if (!defaultProp) {
        defaultProp = {
          label: 'name',
          id: 'ID',
          pid: 'pid'
        };
      }
      var dataArray = [];
      datas.forEach(function (data) {
        var pid = data[defaultProp.pid];
        if (pid == bigPid) {
          var objTemp = {};
          for (var pl in data) {
            //数组对象遍历
            objTemp[pl] = data[pl];
          }
          dataArray.push(objTemp);
        }
      });
      return this.data2treeDG(datas, dataArray, defaultProp);
    },
    data2treeDG: function data2treeDG(datas, dataArray, defaultProp) {
      for (var j = 0; j < dataArray.length; j++) {
        var dataArrayIndex = dataArray[j];
        var childrenArray = [];
        var Id = dataArrayIndex[defaultProp.id];
        for (var i = 0; i < datas.length; i++) {
          var data = datas[i];
          var pid = data[defaultProp.pid];
          if (pid == Id) {
            //判断是否为儿子节点
            var objTemp = {};
            for (var pl in data) {
              //数组对象遍历
              objTemp[pl] = data[pl];
            }
            childrenArray.push(objTemp);
          }
        }
        dataArrayIndex.children = childrenArray;
        if (childrenArray.length > 0) {
          //有儿子节点则递归
          this.data2treeDG(datas, childrenArray, defaultProp);
        }
      }
      return dataArray;
    }
  }
};